'use strict';

import { IScope } from "angular";
import RestService from "../../../../../services/rest.service";
import { FileUploader } from "angular-file-upload";

require('./admin.logo.component.scss');

export default class AdminLogoSettingsComponent {
  public restrict: string;
  public template: any;
  public scope: any;
  public controller: any;
  public controllerAs: string;
  public bindToController: boolean;

  constructor() {
    this.restrict = 'EA';
    this.template = require('./admin.logo.component.html');
    this.scope = {
    };
    this.controller = AdminLogoComponentController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }

}

/* @ngInject */
class AdminLogoComponentController {
  private isLoading: boolean = false;
  private restService: RestService;
  private $scope: IScope;
  private uploadType: UploadType = UploadType.IMAGE_BACKGROUND;
  public uploader: FileUploader;

  public currentFile: any;
  public randomNumber = Math.random(); /** random number we append to the image url to avoid caching problems and trigger image reload manually */


  constructor($scope: IScope, restService: RestService
  ) {
    this.restService = restService;
    this.$scope = $scope;
    this.uploader = this.restService.createImageUploader();

    this.uploader.onAfterAddingFile = (element) => {
      this.isLoading = true;
      this.currentFile = element;
      this.uploader.uploadAll();
    }

    this.uploader.onBeforeUploadItem = (item) => {
      //Change upload path
      item.url = `${this.restService.getBaseUrl()}/admin/settings/logo?type=${this.uploadType}&fileName=${encodeURIComponent(this.currentFile.file.name)}`;
    };

    this.uploader.onCompleteAll = () => {
      this.isLoading = false;
      this.triggerImageReload();
      this.uploader.clearQueue();
    };

  }

  private triggerImageReload() {
    this.randomNumber = Math.random();
  }

  selectUploadType(type: UploadType) {
    this.uploadType = type;
  }

  getUrl(img: string): string {
    return `${this.restService.getStaticImageUrl(img)}&random=${this.randomNumber}`;
  }

  async deleteImage(type: UploadType) {
    await this.restService.deleteImage(type);
    this.triggerImageReload();
  }

}

export enum UploadType {
  IMAGE_HEADER = 'IMAGE_HEADER',
  IMAGE_LOGO = 'IMAGE_LOGO',
  IMAGE_BACKGROUND = 'IMAGE_BACKGROUND'
}